import { whiteLabelingConfig } from '@/utils/whiteLabeling';

import colors from './colors';
import fonts from './fonts';
import mixins from './mixins';
import rounds from './rounds';
import spacings from './spacings';

export default {
  colors,
  fonts,
  rounds,
  spacings,
  mixins,
  impairment: false,
  stepperSize: '340px',
  defaultContentWidth: '1104px',

  controls: {
    size: 24,
    padding: 2,
    formWidth: {
      width: '320px',
    },
    tetriaryAccentButton: whiteLabelingConfig?.tetriaryAccentButton || false,
    mediumSize: '160px',
    height: '40px',
    mobileFieldHeight: '48px',
    maxHeight: '54px',
    sidebarSize: '272px',
    mediumSidebarSize: '240px',
    width: '200px',
    mediumWidth: '280px',
    minifiedSidebarSize: '80px',
    mobileHeightWithMenu: 'calc(100vh - 146px)',
    mobileHeightWithNavigation: 'calc(100vh - 186px)',
    mobileHeightWithBackButton: 'calc(100vh - 64px)',
    buttons: {
      height: {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        height: '40px',
      },
      minWidth: {
        'min-width': '130px',
        'box-sizing': 'border-box',
      },
    },
  },
  shadows: {
    default: {
      'box-shadow': whiteLabelingConfig?.shadows?.default || '0px 6px 15px rgba(0, 0, 0, 0.03)',
    },
    hover: {
      'box-shadow': whiteLabelingConfig?.shadows?.hover || '0px 8px 15px rgba(0, 38, 102, 0.1)',
    },
    active: {
      'box-shadow': whiteLabelingConfig?.shadows?.active || '0px 8px 25px rgba(0, 38, 102, 0.2)',
    },
    highlighted: {
      'box-shadow': whiteLabelingConfig?.shadows?.highlighted || '0px 6px 16px rgba(23, 106, 246, 0.5)',
    },
  },
  padding: {
    regular: '16px',
  },
  border: {
    transparent: {
      border: '0px solid transparent',
    },
    primary: {
      border: `2px solid ${colors.accentActive}`,
    },
    secondary: {
      border: `2px solid ${colors.buttonSecondaryActiveBorder}`,
    },
    primaryBig: {
      border: `3px solid ${colors.accentActive}`,
    },
    grey: {
      border: `1px solid ${colors.border}`,
    },
    grey4: {
      border: `1.5px solid ${colors.border}`,
    },
    grey4bold: {
      border: `2px solid ${colors.border2}`,
    },
    grey5: {
      border: `1px solid ${colors.border1}`,
    },
    grey5bold: {
      outline: `2px solid ${colors.border1}`,
    },
    grey6: {
      border: `1px solid ${colors.border2}`,
    },
    blueGray2: {
      border: `1px solid ${colors.border1}`,
    },
    warning: {
      border: `1px solid ${colors.warningBorder}`,
    },
    bottom: {
      grey4: {
        'border-bottom': `1px solid ${colors.border2}`,
      },
      grey6: {
        'border-bottom': `1px solid ${colors.border2}`,
      },
    },

    left: {
      grey: {
        'border-left': `1px solid ${colors.border1}`,
      },
    },
  },

  height: {
    input: {
      height: '40px',
    },
    largeInput: {
      height: '54px',
    },
    activity: {
      'min-height': '64px',
    },
    card: {
      'min-height': '180px',
    },
  },
  animtaion: {
    fast: {
      transition: 'all 0.15s',
    },
  },
  dashedBox: {
    primary: {
      backgroundImage:
        "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%234588F8FF' stroke-width='2' stroke-dasharray='4%2c 4' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")",
      borderRadius: '12px',
    },
  },
  input: {
    common: {
      width: '100%',
      flex: 1,
      color: colors.textBody,
      'min-height': '40px',
      outline: 'none',
      'box-sizing': 'border-box',
    },
    hover: {
      'border-width': spacings.spacing2,
    },
    placeholder: {
      color: colors.textDisabled,
    },
    focus: {
      'border-color': colors.accentActive,
      'border-width': spacings.spacing2,
      'box-shadow': '0px 0px 0px 5px rgba(23, 106, 246, 0.12)',
    },
    disabled: {
      'border-color': colors.border1,
      'background-color': colors.border1,
      color: colors.textDisabled,
      cursor: 'not-allowed',
    },
    error: {
      'border-color': colors.danger,
      'border-width': spacings.spacing2,
    },
  },
  ellipsis: {
    'white-space': 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  formFieldsEdging: {
    padding: spacings.spacing24,
    outline: `${spacings.spacing24} solid ${colors.module}`,
    borderRadius: rounds.container1Round,
    margin: spacings.spacing24,
  },
  mobileFormFieldsEdging: {
    padding: spacings.spacing16,
    outline: `${spacings.spacing16} solid ${colors.module}`,
    borderRadius: rounds.container1Round,
    margin: spacings.spacing16,
  },
  deviceSize: {
    moreThen: {
      laptop: '(min-width: 1024px)',
      laptopM: '(min-width: 1200px)',
      laptopL: '(min-width: 1440px)',
      mobileL: '(min-width: 425px)',
    },
    lessThen: {
      laptop: '(max-width: 1024px)',
      laptopM: '(max-width: 1200px)',
      laptopL: '(max-width: 1440px)',
      mobileL: '(max-width: 425px)',
    },
  },
  // fontFamilty,
};
